<template>
  <div>
    <b-row>

      <!-- ==============================  FILTERS_SECTION START ============================== -->
      <b-col class="col-lg-2 col-md-3 col-12">
        <AppSearchInput
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="search"
        />
      </b-col>
      <b-col
        class="col-lg-2 col-md-3 col-12"
      >
        <b-form-group :label="$t('filter_by_brigade') + ':'">
          <v-select
            v-model="filter.brigade"
            class="bg-white rounded"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :get-option-label="(el) => {return el.title;}"
            :options="GET_BRIGADE.results"
            :reduce="(p) => p.id"
            @input="onFiltered"
            @search="onAuthorSearch"
          >
            <li slot="list-footer" class="pagination">
              <button :disabled="!GET_BRIGADE.previous" @click="previousBrigade">
                {{ $t("prev") }}
              </button>
              <button :disabled="!GET_BRIGADE.next" @click="nextBrigade">
                {{ $t("next") }}
              </button>
            </li>
          </v-select>
        </b-form-group>
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('filter_by_status') + ':'">
          <v-select
            v-model="filter.status"
            class="bg-white rounded"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :options="GET_APPLICATION_STATUS.results"
            :reduce="(p) => p.id"
            @input="onFiltered"
          />
        </b-form-group>
      </b-col>

      <b-col
        class="col-lg-2 col-md-3 col-12"
      >
        <b-form-group :label="$t('filter_by_objects') + ':'">
          <v-select
            v-model="filter.storage"
            class="bg-white rounded"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="GET_APPLICATION_TYPE"
            :reduce="(p) => p.id"
            @input="onFiltered"
          />
        </b-form-group>
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('dateFromTo') + ':'">
          <VueDataPicker
            v-model="dateFilter"
            placeholder=""
            :other-props="{ 'is-range': true }"
            @input="datePicker"
          />
        </b-form-group>
      </b-col>

      <b-col
        class="col-lg-2 col-md-3 col-12 text-right mt-75"
        v-if="checkButtonPermission(['builder', 'admin'])"
      > 
        <b-button variant="primary" class="mt-1 w-100"
         @click="$router.push({ name: 'add-works' })"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{$t('add')}}
        </b-button>

        <!-- <b-button
          v-b-modal.add-app
          class="mt-1 w-100"
          variant="primary"
          @click="$router.push({ name: 'add-works' })"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{ $t("add") }}
        </b-button> -->
      </b-col>
      <!-- ==============================  FILTERS_SECTION END ============================== -->







      <b-col class="col-md-12 col-12 mt-2">
        <!-- ==============================  TABLE_SECTION START ============================== -->
        <!-- <b-card > -->
        <b-table
          v-if="!isLoading"
          id="user-table"
          class="px-1 rounded bg-light-secondary dark"
          :fields="fields"
          :items="GET_APPLICATION_FOR_BRIGADE_WORKS.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(from)="props">
            <h6
              class="font-weight-bolder"
              v-if="props && props.item && props.item.author"
            >
              {{ props.item.storage.rc_object }}
            </h6>
          </template>

          <template #cell(sum_total)="props">
            <span v-if="props && props.item && props.item.sum_total">
              {{ $_formatPriceMixin(props.item.sum_total) }} сум
            </span>
          </template>

          <template #cell(storage)="props">
            <span v-if="props && props.item && props.item.storage">
              {{ props.item.storage.title }}
            </span>
          </template>
          
          <template #cell(work_type)="props">
            <template v-if="props && props.item && props.item.work_type">
              <span v-for="(item, index) in props.item.work_type" :key="index">
                <b-badge class="mb-25 ml-50">
                  {{ item }}
                </b-badge>
              </span>
            </template>
          </template>

          <template #cell(brigade)="props">
            <div v-if="props && props.item && props.item.brigade">
              <b-badge class="mb-25 ml-50">
                {{ props.item && props.item.brigade ? props.item.brigade : '' }}
              </b-badge>
            </div>
          </template>

          <template #cell(status)="props">
            <b-badge
              v-if="props && props.item && props.item.status"
              :variant="props.item.status.color"
            >
              <span>{{ props.item.status.name }}</span>
            </b-badge>
            <feather-icon
              v-if="props && props.item && props.item.status"
              v-b-tooltip.focus="{ variant: props.item.status.color }"
              :title="props.item.status.description"
              class="ml-25"
              icon="InfoIcon"
              size="24"
            />
          </template>

          <template #cell(created_at)="props">
            <h6 class="font-weight-bolder">
              {{ $dayjs(props.value).format("DD.MM.YYYY") }} <br />
              {{ $dayjs(props.value).format("HH:mm") }}
            </h6>
          </template>
     
          <template #cell(work_place)="props">
            <h6 class="font-weight-bolder" v-if="props.item && props.item.work_place && props.item.work_place[$i18n.locale]">
              {{ props.item.work_place[$i18n.locale] }} <br />
            </h6>
          </template>
   
          <template #cell(work_date)="props">
            <h6 class="font-weight-bolder">
              {{ $dayjs(props.value).format("DD.MM.YYYY") }} <br />
            </h6>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                v-if="props.item"
                v-b-tooltip.hover.v-primary
                :title="$t('watch')"
                size="sm"
                variant="primary"
                class="mt-50 mb-50"
                @click="$router.push(`/applications/works/view/${props.item.id}`)"
              >
                <feather-icon icon="EyeIcon" size="15" />
              </b-button>

              <b-button
                v-if="
                  props &&
                  props.item &&
                  props.item.status &&
                  props.item.status.is_editable
                "
                v-b-tooltip.hover.v-warning
                :title="$t('edit')"
                size="sm"
                variant="warning"
                class="ml-50 mt-50 mb-50"
                @click="$router.push(`/applications/works/${props.item.id}`)"
              >
                <feather-icon icon="EditIcon" size="15" />
              </b-button>
              <b-button
                v-if="props.item.status.is_editable && !(currentUserRole.includes('foreman'))"
                v-b-tooltip.hover.v-danger
                :title="$t('delete')"
                size="sm"
                variant="danger"
                class="ml-50 mt-50 mb-50"
                @click="deleteWork(props)"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
            </div>
          </template>
        </b-table>
        <!-- </b-card> -->

        <b-card v-else>
          <Loader />
        </b-card>
        <!-- ==============================  TABLE_SECTION END ============================== -->
      </b-col>





      <!-- ==============================  PAGINATION_SECTION START ============================== -->
      <b-col>
        <b-card class="">
          <span>{{$t('very_total_amount')}}:</span>
          {{$_formatPriceMixin(GET_APPLICATION_FOR_BRIGADE_WORKS.sum_total)}} сум
        </b-card>
        <Pagination
          class="w-100"
          :params="filter"
          :rows="GET_APPLICATION_FOR_BRIGADE_WORKS.count"
          @refresh="refresh"
          :page="filter.page"
          :page_size="filter.page_size"
          :page_options="['3','5','10','50','100', {text: 'Все', value: 100000}]"
        />
      </b-col>


      <fields :works_data="works_data" />
      <!-- ==============================  PAGINATION_SECTION END ============================== -->


    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BButton,
  BTable,
  BCard,
  BFormGroup,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations  } from "vuex";
import vSelect from "vue-select";
import AppSearchInput from "@/components/AppSearchInput.vue";
import VueDataPicker from "@/components/VueDatePicker.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import check from "@/mixins/check";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";
import useJwt from "@/auth/jwt/useJwt";
import fields from "./fields.vue";

export default {
  components: {
    BCol,
    BRow,
    BButton,
    BFormGroup,
    vSelect,
    AppSearchInput,
    VueDataPicker,
    BTable,
    BBadge,
    Loader,
    BCard,
    Pagination,
    fields,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [areYouSure, check, priceFormatMixin, loader],
  data() {
    return {
      isLoading: false,
      works_data: {},



      // ===============  PRIMARY_DATA_SECTION START ===============
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "object",
          key: "from",
          thClass: "tableHeadClass",
        },
        {
          label: "brigade",
          key: "brigade",
          thClass: "tableHeadClass",
        },
        {
          label: "reference.categoriya",
          key: "work_type",
          thClass: "tableHeadClass",
        },
        {
          label: "place_of_work",
          key: "work_place",
          thClass: "tableHeadClass",
        },
        {
          label: "status",
          key: "status",
          thClass: "tableHeadClass",
        },
        {
          label: "total_amount",
          key: "sum_total",
          thClass: "tableHeadClass",
        },
        {
          label: "date",
          key: "work_date",
          thClass: "tableHeadClass",
        },
        {
          label: "general.created_at_application",
          key: "created_at",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
      filter: {
        brigade: null,
        status: null,
        search: null,
        storage: null,
        page_size: 10,
        page: 1,
      },
      dateFilter: {
        start_date: null,
        end_date: null,
      },
      currentUserRole: '',
      brigadePage: 1,
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  computed: {
    ...mapGetters("application", [
      "GET_APPLICATION_FOR_BRIGADE_WORKS",
      "GET_APPLICATION_STATUS",
      "GET_APPLICATION_AUTHOR",
      "GET_APPLICATION_TYPE",
    ]),
    ...mapGetters('brigade', ['GET_BRIGADE']),


  },
  async mounted() {
    const { role } = useJwt.getUserData();
    this.currentUserRole = role

    // await this.$_loaderStart();
    this.isLoading = true;




    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATION_AUTHOR({ role_unique_name: "builder" })
    await this.FETCH_BRIGADE()
    await this.FETCH_APPLICATION_STATUS({ content_type_model: "requirements_b" });
    await this.FETCH_APPLICATION_TYPE({ is_object: 1, mini: true });

    let page = this.$route.query.page
    let page_size = this.$route.query.page_size
    await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS({ page: page ? page : 1, page_size: page_size ? page_size : 10 });

    if(page){
      this.filter.page = page
    }
    if(page_size){
      this.filter.page_size = page_size
    }
    // ===============  PRIMARY_REQUESTS_SECTION END ===============




    
    this.isLoading = false;
  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "FETCH_APPLICATION_FOR_BRIGADE_WORKS",
      "DELETE_APPLICATION_FOR_BRIGADE_WORKS",
      "FETCH_APPLICATION_STATUS",
      "FETCH_APPLICATION_AUTHOR",
      "FETCH_APPLICATION_TYPE",
    ]),
    ...mapActions('brigade', ['FETCH_BRIGADE']),







    // ===============  PAGINATION_SECTION START ===============
    async previousBrigade() {
      if (this.GET_BRIGADE.previous) {
        this.brigadePage--;

        await this.FETCH_BRIGADE({ page: this.brigadePage });
      }
    },

    async nextBrigade() {
      if (this.GET_BRIGADE.next) {
        this.brigadePage++;

        await this.FETCH_BRIGADE({ page: this.brigadePage });
      }
    },
    // ===============  PAGINATION_SECTION START ===============








    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      this.isLoading = true;

      await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS({
        ...this.filter,
        ...this.dateFilter,
      });

      this.$router.replace({ path: "/applications/works", query: { page: this.filter.page, page_size: this.filter.page_size } });

      this.isLoading = false;
    },
    // ===============  REFRESH_SECTION END ===============







    // ===============  SEARCH_SECTION START ===============
    async onFiltered() {
      this.isLoading = true;
      this.filter.page = 1;
      await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS({
        ...this.filter,
        ...this.dateFilter,
      });
      this.isLoading = false;
    },
    async onAuthorSearch(value) {
      if (value) {
        clearTimeout(this._timerId);
        this._timerId = setTimeout(async () => {
          await this.FETCH_APPLICATION_AUTHOR({
            mini: true,
            search: value,
            role_unique_name: "builder",
          });
        }, 500);
      }
    },
    async search(text) {
      this.isLoading = true;
      this.filter.page = 1;
      this.filter.search = text;
      await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS(this.filter);
      this.isLoading = false;
    },
    // ===============  SEARCH_SECTION END ===============









    // ===============  DATE_PICKER_SECTION START ===============
    async datePicker(e) {
      this.isLoading = true;
      this.filter.page = 1;
      if (e) {
        this.dateFilter.start_date = e.start;
        this.dateFilter.end_date = e.end;
        await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS({
          ...this.filter,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });
      } else {
        await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS({ ...this.filter });
      }
      this.isLoading = false;
    },
    // ===============  DATE_PICKER_SECTION END ===============

















    // ===============  DELETE_SECTION START ===============
    deleteWork(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_APPLICATION_FOR_BRIGADE_WORKS(props.item.id)
            .then(() => {
              this.FETCH_APPLICATION_FOR_BRIGADE_WORKS(this.filter);
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============








    // ===============  CHECK_AND_DISABLE_SECTION START ===============
  
    // ===============  CHECK_AND_DISABLE_SECTION END ===============






  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

.dark-layout #user-table .tableRowClass {
  background: #19213a;
}

.dark-layout .dark {
  background-color: #283046 !important;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 15px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
